import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withComponentInputBinding, withEnabledBlockingInitialNavigation } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { AppComponent, UploadInterceptor } from './app/app.component';
import { routes } from './app/app.routes';
import '@progress/kendo-angular-intl/locales/pt/all';

// MSAL
import {
  MsalModule,
  MsalGuard,
  MsalService,
  MsalBroadcastService,
} from '@azure/msal-angular';

import { msalConfig, msalGuardConfig, msalInterceptor, msalInterceptorConfig } from './app/_authorization/auth.config';
import { DatePipe, registerLocaleData } from '@angular/common';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { PublicClientApplication } from '@azure/msal-browser';
import localePt from '@angular/common/locales/pt';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomPaginator } from './app/_utils/CustomPaginatorConfiguration';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_DATE_FORMATS } from 'src/app/_utils/calendar-date-format.utils';

// @ts-ignore
import 'moment/locale/pt-br';

registerLocaleData(localePt);

bootstrapApplication(AppComponent, {

  providers: [

    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimations(),
    // provideNativeDateAdapter(),
    provideMomentDateAdapter(MY_DATE_FORMATS),

    provideRouter(
      routes,
      withComponentInputBinding(), 
      withEnabledBlockingInitialNavigation()
    ),

    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([
          // Interceptor que anexa o token automaticamente
          msalInterceptor
      ])
    ),
    
    importProvidersFrom(
      MsalModule.forRoot(
        new PublicClientApplication(msalConfig),
        msalGuardConfig,
        msalInterceptorConfig
      )
    ),

    MsalService,
    MsalGuard,
    MsalBroadcastService,

    DatePipe,

    {
      provide: HTTP_INTERCEPTORS,
      useClass: UploadInterceptor, 
      multi: true
    },
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR'
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'pt-BR'
    },
    {
      provide: MatPaginatorIntl,
      useFactory: CustomPaginator
    }
  ]
}).catch(err => console.error(err));